import { render, staticRenderFns } from "./WebAwesomeReleaseNotice.vue?vue&type=template&id=60442881"
import script from "./WebAwesomeReleaseNotice.vue?vue&type=script&lang=js"
export * from "./WebAwesomeReleaseNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports